/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


const yearsWrapper = document.querySelector('.years_wrapper');
var elementssp = document.querySelectorAll('.years_wrapper');
var numberOfElements = elementssp.length;
if(numberOfElements > 0) {
let isDragging = false;
let startX = 0;
let scrollLeft = 0;

yearsWrapper.addEventListener('mousedown', (e) => {
  isDragging = true;
  startX = e.pageX - yearsWrapper.offsetLeft;
  scrollLeft = yearsWrapper.scrollLeft;

  yearsWrapper.style.cursor = 'grabbing'; // Change cursor while dragging
});

yearsWrapper.addEventListener('mouseleave', () => {
  isDragging = false;
  yearsWrapper.style.cursor = 'grab'; // Reset cursor when not dragging
});

yearsWrapper.addEventListener('mouseup', () => {
  isDragging = false;
  yearsWrapper.style.cursor = 'grab'; // Reset cursor when not dragging
});

yearsWrapper.addEventListener('mousemove', (e) => {
  if (!isDragging) return;
  e.preventDefault();
  const x = e.pageX - yearsWrapper.offsetLeft;
  const walk = (x - startX) * 3; // Adjust scrolling speed as needed
  yearsWrapper.scrollLeft = scrollLeft - walk;
});

}

document.addEventListener('DOMContentLoaded', function() {
  // Check if the screen width is below 768 pixels (adjust as needed)
  var collectionInnerHiddenPocket = document.querySelector('.CollectionInner__Sidebar.hidden-pocket');

// If the element exists, remove the "no-scroll" class from the html element
if (collectionInnerHiddenPocket) {
  document.documentElement.classList.remove('no-scroll');
}
});


$('.Product__SlideshowNavScroller').flickity({
  asNavFor: '.Product__Slideshow',
  pageDots: false,
  cellAlign: 'left',
  // wrapAround: true,
  contain: false,
  prevNextButtons: false,
  groupCells: 1
});

 document.addEventListener('DOMContentLoaded', function() {
   if(document.querySelector('#collection-filters-sidebar-form .DropdownMenu_filter.nn')){
     
      var dropdownMenu = document.querySelector('#collection-filters-sidebar-form .DropdownMenu_filter.nn');
      var customActiveItem = document.querySelector('#collection-filters-sidebar-form .Linklist__Item.custom-active-url');
      var customdrop =  customActiveItem?.closest('.DropdownMenu_filter.nn') || null;
         if (customdrop) {
        // If custom-active-url is present, show the dropdown menu
           console.log(customdrop);
        customdrop.style.display = 'block';
      }
   }
});

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function(){
    if(window.location.hash != ''){
      $('html,body').animate({
        scrollTop: $(window.location.hash).offset().top
      });
      }
  },600);
  
});

// Select the element using querySelector
const heading = document.querySelector('.heading_hightlights h2');

if(heading){
  // Change the inner text
  heading.innerText = 'Belangrijke punten';
}
